import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core';
import { Alert, AlertTitle, AlertProps } from '@material-ui/lab';
import React, { FunctionComponent, ReactNode } from 'react';
interface IBasicAlertProps {
  title?: string;
  description?: ReactNode;
  icon?: IconProp;
  severity?: AlertProps['severity'];
}
const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 'bold',
    paddingBottom: theme.spacing(2)
  }
}));
const useAlertStyles = makeStyles(theme => ({
  message: {
    flex: '1 1 auto'
  }
}));
const BasicAlert: FunctionComponent<IBasicAlertProps> = ({
  title,
  description,
  icon,
  severity
}) => {
  const classes = useStyles();
  const alertClasses = useAlertStyles();
  if (!title && !description) {
    return null;
  }
  return <Alert icon={icon ? <FontAwesomeIcon fixedWidth icon={icon} /> : undefined} severity={severity} classes={alertClasses} data-sentry-element="Alert" data-sentry-component="BasicAlert" data-sentry-source-file="BasicAlert.tsx">
            {title && <AlertTitle className={classes.title}>{title}</AlertTitle>}
            {description}
        </Alert>;
};
export default BasicAlert;